import { createActions, createReducer } from 'reduxsauce';
import { combineReducers } from 'redux';

export const { Types: types, Creators: actions } = createActions(
  {
    applyCoupon: ['couponId', 'payByPoints'],
    applyCouponSuccess: ['couponId', 'data'],
    applyCouponFailure: ['couponId', 'error'],
    getApplyCoupon: ['couponId', 'resolve', 'reject'], // New action for fetching a coupon by ID
    getApplyCouponSuccess: ['couponId', 'data'], // Success action for fetching a coupon by ID
    getApplyCouponFailure: ['couponId', 'error'], // Failure action for fetching a coupon by ID
  },
  { prefix: 'cb/coupons/apply/' },
);

export const applyCoupon = combineReducers({
  fetching: createReducer(false, {
    [types.APPLY_COUPON]: () => true,
    [types.APPLY_COUPON_SUCCESS]: () => false,
    [types.APPLY_COUPON_FAILURE]: () => false,
    [types.GET_APPLY_COUPON]: () => true, // Handle fetching state for GET
    [types.GET_APPLY_COUPON_SUCCESS]: () => false, // Handle success state for GET
    [types.GET_APPLY_COUPON_FAILURE]: () => false, // Handle failure state for GET
  }),
  data: createReducer(null, {
    [types.APPLY_COUPON_SUCCESS]: (_, { data }) => data,
    [types.APPLY_COUPON_FAILURE]: () => null,
    [types.GET_APPLY_COUPON_SUCCESS]: (_, { data }) => data, // Handle success state for GET
    [types.GET_APPLY_COUPON_FAILURE]: () => null, // Handle failure state for GET
  }),
  error: createReducer(null, {
    [types.APPLY_COUPON]: () => null,
    [types.APPLY_COUPON_SUCCESS]: () => null,
    [types.APPLY_COUPON_FAILURE]: (_, { error }) => error,
    [types.GET_APPLY_COUPON]: () => null, // Handle fetching state for GET
    [types.GET_APPLY_COUPON_SUCCESS]: () => null, // Handle success state for GET
    [types.GET_APPLY_COUPON_FAILURE]: (_, { error }) => error, // Handle failure state for GET
  }),
});

export default (state = {}, action) => {
  const { type, couponId } = action;

  if (Object.values(types).includes(type)) {
    return {
      ...state,
      [couponId]: applyCoupon(state[couponId], action),
    };
  }

  return state;
};
